<template>
  <v-form class="mb-3" autocomplete="off" @submit.prevent="">
    <v-row class="filters" align="center" justify="start">
      <v-col class="mt-0 pt-0 pr-11">
        <v-row class="mt-3">
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model.trim="filters.searchTerm"
              label="Hledat"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              :prepend-icon="filters.searchTerm ? 'mdi-close' : 'mdi-none'"
              @click:append="filter"
              @click:prepend.prevent="removeFromFilter('searchTerm')"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model="filters.ids"
              v-mask="'######'"
              label="Id dodavatele"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.ids ? 'mdi-close' : 'mdi-none'"
              min="1"
              step="1"
              @click:prepend="filters.ids = null"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model="filters.tzbProductIds"
              v-mask="'######'"
              label="Id produktu TZB"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.tzbProductIds ? 'mdi-close' : 'mdi-none'"
              min="1"
              step="1"
              @click:prepend="filters.tzbProductIds = null"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col v-if="false" cols="12" sm="6" md="4" lg="3" class="pb-0">
            <VAutocompleteWithValidation
              v-model="filters.type"
              label="Typ"
              outlined
              dense
              background-color="white"
              item-text="text"
              item-value="name"
              :items="types"
              :loading="typesLoading"
              :icon="filters.type ? 'mdi-close' : 'mdi-none'"
              @click:prepend="filters.type = null"
              @keydown.enter="filter()"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pr-11 pb-6 text-right">
        <v-btn depressed height="40px" min-width="130px" outlined @click="resetFilter">
          Zrušit filtr
        </v-btn>

        <v-btn
          depressed
          height="40px"
          min-width="130px"
          color="primary"
          class="ml-4"
          @click="filter"
        >
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'

export default {
  name: 'SuppliersFilters',
  components: { VAutocompleteWithValidation },
  data() {
    return {
      filters: {
        searchTerm: null,
        ids: null,
        tzbProductIds: null,
        type: null,
      },
      types: [],
      typesLoading: false,
    }
  },
  computed: {
    filtersFilled() {
      let state = false
      Object.keys(this.filters).forEach((filter) => {
        if (filter !== 'searchTerm') {
          if (this.filters[filter]) {
            state = true
            return true
          }
        }
        return state
      })
      return state
    },
  },
  async created() {
    const ref = this
    // eslint-disable-next-line no-unused-vars
    this.$eventBus.$on('productResetFilter', function (value) {
      ref.resetFilter()
    })
    this.setFilter()
    this.loadServiceTypes()
  },
  methods: {
    ...mapActions({
      getSupplierTypes: 'enum/listSupplierServiceTypes',
    }),
    filter() {
      const filters = {
        ...this.filters,
      }
      this.$emit('filter', filters)
    },
    removeFromFilter(removingFilter) {
      this.filters[removingFilter] = null
      this.filter()
    },
    resetFilter() {
      Object.keys(this.filters).forEach((filter) => {
        this.filters[filter] = null
      })
      this.$emit('filter', this.filters)
    },
    setFilter() {
      if (Object.values(this.$route.query)) {
        Object.entries(this.$route.query).forEach((keyValue) => {
          const [key, value] = keyValue
          if (key !== 'searchTerm') {
            this.filters[key] = Number(value) || value
          } else {
            this.filters[key] = value
          }
        })
      }
    },
    loadServiceTypes() {
      this.typesLoading = true
      this.getSupplierTypes()
        .then((response) => {
          this.types = response.data
        })
        .finally(() => {
          this.typesLoading = false
        })
    },
  },
}
</script>
